import { BaseApi } from "./BaseApi";

export class LicenciamentoApi extends BaseApi {
    async obterPorta() : Promise<number> {
        try {
            return (await this.api.get('http://localhost:4444/api/licenciamento/ObterPorta')).data
        } catch (error) {
            return null
        }
        
    }

    async obterLicenciamento(porta:number) : Promise<string> {
        return (await this.api.get(`http://localhost:${porta}/api/Licenciamento/Obter`,{
            params: {
                port: porta
            }
        })).data
    }
}